import {initRepoSettingsBranchesDrag} from '../../js/features/repo-settings-branches.ts';
import {initOrgSettingBranches} from '../../js/features/org-settings.ts';
import {initAdminUserList} from '../../js/features/admin/users.ts';
import {initUserAuthSAML} from './features/user-auth.ts';
import {initAgentActionMatrix, initAgentAvatarPresets, initAgentCodetServerModelReload, initAgentConnectionAccessModes, initAgentPermissionCommandMode, initAgentPrincipalPickers} from './features/agents.ts';
import {initAgentSessions} from './features/agent-sessions.ts';
import {initAuditLogFilter} from './features/admin/audit.ts';
import {initGlobalAnnouncement} from './features/admin/announcement.ts';
import {initAdminDevopsDashboardConfig} from './features/admin/devops-dashboard-config.ts';
import {initDevopsDashboard} from './features/devops-dashboard.ts';
import {initRepoSettingsSecurity} from './features/repo-settings-security.ts';
import {initRepoSettingsUserGroups} from './features/repo-settings-user-groups.ts';
import {initCompSearchUserGroupBox} from './features/user-group-selector.ts';
import {initPushRules} from './features/push-rules.ts';

export function initEE() {
  initRepoSettingsBranchesDrag(); // for org protected branches drag and drop
  initOrgSettingBranches(); // for org protected branches form toggles

  initAgentActionMatrix();
  initAgentAvatarPresets();
  initAgentCodetServerModelReload();
  initAgentPermissionCommandMode();
  initAgentConnectionAccessModes();
  initAgentPrincipalPickers();
  initAgentSessions();
  initUserAuthSAML();
  initAdminUserList(); // bulk delete/disable buttons on the admin user list
  initAuditLogFilter();
  initGlobalAnnouncement();
  initAdminDevopsDashboardConfig();
  initDevopsDashboard();
  initRepoSettingsSecurity();
  initRepoSettingsUserGroups();
  initCompSearchUserGroupBox();
  initPushRules();
}
